"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerBodyClassNames: function() {
        return drawerBodyClassNames;
    },
    useDrawerBodyStyles_unstable: function() {
        return useDrawerBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const drawerBodyClassNames = {
    root: 'fui-DrawerBody'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__resetStyles)("ri6rvx7", null, [
    ".ri6rvx7{padding:0 var(--spacingHorizontalXXL);flex:1;align-self:stretch;position:relative;z-index:1;overflow:auto;}",
    ".ri6rvx7:last-child{padding-bottom:calc(var(--spacingHorizontalXXL) + 1px);}",
    ".ri6rvx7:first-child{padding-top:calc(var(--spacingHorizontalXXL) + 1px);}"
]);
const useDrawerBodyStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(drawerBodyClassNames.root, styles, state.root.className);
    return state;
}; //# sourceMappingURL=useDrawerBodyStyles.styles.js.map
